export default "__VITE_ASSET__a576a059__"